<template>
  <!-- BREADCRUMB (mode: detail) -->
  <div v-if="mode === 'detail'" class="d-flex align-items-center gap-2 mb-3" style="font-size:0.875rem">
    <a class="text-primary fw-semibold" style="cursor:pointer"
      @click="$router.push($route.query.from || '/asset/infrastructure-it')">
      Aset Infrastruktur IT
    </a>
    <i class="bi bi-chevron-right text-muted" style="font-size:12px"></i>
    <span class="text-muted">Details</span>
  </div>
  
  <!-- BACK LINK (mode: add/edit) -->
  <div v-if="mode === 'add' || mode === 'edit'" class="mb-3">
    <a class="d-flex align-items-center gap-2 text-primary fw-semibold" style="cursor:pointer;width:fit-content"
      @click="goBack">
      <i class="bi bi-arrow-left"></i> Back
    </a>
  </div>
  <div class="card-modern p-4">
  
    <!-- PAGE HEADER -->
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h3 class="fw-bold text-dark">{{ pageTitle }}</h3>
      <button v-if="mode === 'detail'" class="btn btn-secondary" @click="goBack">Back</button>
    </div>
  
    <!-- ==================== DETAIL MODE ==================== -->
    <template v-if="isDetail">
  
      <!-- HEADER INFO -->
      <div class="border rounded p-3 mb-3">
        <p class="fw-semibold text-muted small text-uppercase mb-3">Informasi Umum</p>
        <div class="row g-3">
          <div class="col-md-4">
            <label class="form-label fw-semibold">Jenis Asset</label>
            <div class="form-control bg-light">{{ detail.device_category_name || '-' }}</div>
          </div>
          <div class="col-md-4">
            <label class="form-label fw-semibold">Site</label>
            <div class="form-control bg-light">{{ detail.mst_site_name || '-' }}</div>
          </div>
          <div class="col-md-4">
            <label class="form-label fw-semibold">Department</label>
            <div class="form-control bg-light">{{ detail.mst_division_name || '-' }}</div>
          </div>
          <div class="col-md-4">
            <label class="form-label fw-semibold">Nama User</label>
            <div class="form-control bg-light">{{ detail.infra_user_name || '-' }}</div>
          </div>
          <div class="col-md-4">
            <label class="form-label fw-semibold">Lokasi Awal</label>
            <div class="form-control bg-light">{{ detail.initial_location_device || '-' }}</div>
          </div>
          <div class="col-md-4">
            <label class="form-label fw-semibold">Lokasi Akhir</label>
            <div class="form-control bg-light">{{ detail.final_location_device || '-' }}</div>
          </div>
          <div class="col-md-4">
            <label class="form-label fw-semibold">Purchase Date</label>
            <div class="form-control bg-light">{{ formatDate(detail.purchase_date) }}</div>
          </div>
          <div class="col-md-4">
            <label class="form-label fw-semibold">Received Date</label>
            <div class="form-control bg-light">{{ formatDate(detail.received_date) }}</div>
          </div>
          <div class="col-md-4">
            <label class="form-label fw-semibold">Handover Date</label>
            <div class="form-control bg-light">{{ formatDate(detail.handover_date) }}</div>
          </div>
          <div class="col-12">
            <p class="fw-semibold text-muted small text-uppercase mt-3 mb-2">Dokumen Pendukung</p>
            <div v-for="doc in detail.documents" :key="doc.document_file_id"
              class="d-flex align-items-center justify-content-between py-2 px-3 border rounded-3 mb-2">
              <div class="d-flex align-items-center gap-2 text-truncate">
                <i class="bi bi-file-earmark-pdf-fill text-danger fs-4"></i>
                <span class="badge bg-secondary flex-shrink-0">{{ doc.document_type_name || '-' }}</span>
                <span class="text-truncate small">{{ doc.file_name || getFileName(doc.file_path) }}</span>
              </div>
              <div class="d-flex align-items-center gap-2 flex-shrink-0">
                <button class="btn btn-outline-primary btn-sm" title="Lihat" @click="downloadFile(doc.file_path)">
                  <i class="bi bi-eye"></i>
                </button>
                <button class="btn btn-outline-secondary btn-sm" title="Download" @click="downloadFile(doc.file_path)">
                  <i class="bi bi-download"></i>
                </button>
              </div>
            </div>
            <div v-if="!detail.documents || !detail.documents.length" class="text-muted small py-2">
              Belum ada dokumen.
            </div>
          </div>
        </div>
      </div>
  
      <!-- DETAIL ITEMS -->
      <div class="d-flex justify-content-between align-items-center mb-2">
        <p class="fw-semibold text-muted small text-uppercase mb-0">Detail Perangkat</p>
      </div>
  
      <div v-for="(item, index) in detail.items" :key="item.infrastructure_detail_id" class="border rounded p-3 mb-3">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <p class="fw-semibold mb-0 small">Item #{{ index + 1 }} — {{ item.device_type_name || '-' }}</p>
        </div>
  
        <div class="row g-3">
          <div class="col-md-4">
            <label class="form-label fw-semibold">Jenis Perangkat</label>
            <div class="form-control bg-light">{{ item.device_type_name || '-' }}</div>
          </div>
          <!-- <div class="col-md-4">
                              <label class="form-label fw-semibold">Tanggal Pembelian Item</label>
                              <div class="form-control bg-light">{{ formatDate(item.detail_tanggal_pembelian) }}</div>
                            </div> -->
  
          <div class="col-md-4">
            <label class="form-label fw-semibold">Status</label>
            <div>
              <span class="badge-modern"
                :class="item.status == 1 ? 'badge-success' : item.status == 2 ? 'badge-warning' : 'badge-danger'">
                {{ item.status == 1 ? 'Active' : item.status == 2 ? 'Retired' : 'Inactive' }}
              </span>
            </div>
          </div>
          <div class="col-md-4">
            <label class="form-label fw-semibold">Kondisi Barang</label>
            <div class="form-control bg-light">{{ item.asset_condition_name || '-' }}</div>
          </div>
  
          <!-- ASSET NUMBERS -->
          <div class="col-md-4">
            <label class="form-label fw-semibold">Nomor Aset</label>
            <div v-if="!item.asset_numbers || item.asset_numbers.length === 0" class="form-control bg-light text-muted">
              -
            </div>
            <div v-else class="d-flex flex-column gap-2">
              <div v-for="num in item.asset_numbers" :key="num.infra_asset_number_id" class="form-control bg-light">
                {{ num.detail_asset_number || '-' }}
              </div>
            </div>
          </div>
  
          <!-- SPECIFICATIONS (dynamic sesuai jenis perangkat) -->
          <div class="col-12">
            <hr class="mt-0 mb-2">
            <label class="form-label fw-semibold">Spesifikasi</label>
            <div v-if="!item.specifications || item.specifications.length === 0" class="text-muted small">
              Tidak ada spesifikasi.
            </div>
            <div v-else class="row g-2">
              <div v-for="spec in item.specifications" :key="spec.specification_id" class="col-md-3">
                <label class="form-label small text-muted mb-0">{{ spec.specification_name }}</label>
                <div class="form-control bg-light">{{ spec.specification_value || '-' }}</div>
              </div>
            </div>
          </div>
  
          <!-- SUBSCRIPTION -->
          <div class="col-12">
            <hr class="mt-0 mb-2">
            <label class="form-label fw-semibold">Subscription</label>
  
            <div v-if="!item.detail_subscription"
              class="alert alert-secondary py-2 px-3 mb-0 d-flex align-items-center gap-2">
              <i class="ti ti-ban" style="font-size:16px;"></i>
              <span class="small">Perangkat ini tidak memiliki subscription</span>
            </div>
  
            <template v-else>
              <div class="row g-3">
                <div class="col-md-4">
                  <label class="form-label fw-semibold">Start Date Subscription</label>
                  <div class="form-control bg-light">{{ formatDate(item.detail_start_date_subscription) }}</div>
                </div>
                <div class="col-md-4">
                  <label class="form-label fw-semibold">End Date Subscription</label>
                  <div class="form-control bg-light">{{ formatDate(item.detail_expired_date_subscription) }}</div>
                </div>
                <div class="col-md-4">
                  <label class="form-label fw-semibold">Nomor Kontrak</label>
                  <div class="form-control bg-light">{{ item.detail_subscription_contract_number || '-' }}</div>
                </div>
              </div>
            </template>
          </div>
  
        </div>
      </div>
    </template>
  
    <!-- ==================== ADD / EDIT MODE ==================== -->
    <template v-else>
      <!-- HEADER FORM -->
      <div class="border rounded p-3 mb-3">
        <p class="fw-semibold text-muted small text-uppercase mb-3">Informasi Umum</p>
        <div class="row g-3">
          <div class="col-md-4">
            <label class="form-label fw-semibold">Jenis Asset <span class="text-danger">*</span></label>
            <Multiselect v-model="form.device_category" :options="deviceCategoryList" valueProp="value"
              label="description" placeholder="Pilih Jenis Asset" :searchable="true" :can-clear="true"/>
          </div>
          <div class="col-md-4">
            <label class="form-label fw-semibold">Site <span class="text-danger">*</span></label>
            <Multiselect v-model="form.mst_site_id" :options="siteList" valueProp="mst_site_id" label="mst_site_name"
              placeholder="Pilih Site " :searchable="true" :can-clear="true" />
          </div>
          <div class="col-md-4">
            <label class="form-label fw-semibold">Departement</label>
            <Multiselect v-model="form.mst_division_id" :options="divisionList" valueProp="mst_division_id"
              label="mst_division_name" placeholder="Pilih Department" :searchable="true" :can-clear="true" />
          </div>
          <div class="col-md-4">
            <label class="form-label fw-semibold">Nama User</label>
            <Multiselect v-model="userSelect" class="uppercase-select" :options="employeeOptions" value-prop="value"
              label="label" track-by="label" :object="true" placeholder="Pilih / ketik nama user" :searchable="true"
              :taggable="true" :create-option="true" :can-clear="true" @change="onUserSelectChange" />
          </div>
          <div class="col-md-4">
            <label class="form-label fw-semibold">Lokasi Awal <span class="text-danger">*</span></label>
            <input type="text" class="form-control" v-model="form.initial_location_device">
          </div>
          <div class="col-md-4">
            <label class="form-label fw-semibold">Lokasi Akhir</label>
            <input type="text" class="form-control" v-model="form.final_location_device">
          </div>
          <div class="col-md-4">
            <label class="form-label fw-semibold">Purchase Date</label>
            <input type="date" class="form-control" v-model="form.purchase_date">
          </div>
          <div class="col-md-4">
            <label class="form-label fw-semibold">Received Date</label>
            <input type="date" class="form-control" v-model="form.received_date">
          </div>
          <div class="col-md-4">
            <label class="form-label fw-semibold">Handover Date</label>
            <input type="date" class="form-control" v-model="form.handover_date">
          </div>
          <div class="col-12">
            <label class="form-label fw-semibold">Dokumen Pendukung</label>
            <small class="text-muted d-block mb-2">
              Upload PDF, max 10MB per file. Bisa lebih dari satu file.
            </small>
  
            <!-- Dokumen tersimpan -->
            <div v-for="(doc, idx) in existingDocuments" :key="'ex-' + doc.document_file_id"
              class="d-flex align-items-center justify-content-between py-2 px-3 mb-2 border rounded-3"
              style="max-width:560px">
              <div class="d-flex align-items-center gap-2 text-truncate">
                <i class="bi bi-file-earmark-pdf-fill text-danger fs-4"></i>
                <span class="badge bg-secondary flex-shrink-0">{{ doc.document_type_name || doc.document_type }}</span>
                <span class="text-truncate small">{{ doc.file_name || getFileName(doc.file_path) }}</span>
              </div>
              <div class="d-flex align-items-center gap-2 flex-shrink-0">
                <button type="button" class="btn btn-outline-primary btn-sm" title="Lihat"
                  @click="downloadFile(doc.file_path)">
                  <i class="bi bi-eye"></i>
                </button>
                <button type="button" class="btn btn-outline-danger btn-sm" title="Hapus"
                  @click="removeExistingDocument(idx)">
                  <i class="bi bi-x-lg"></i>
                </button>
              </div>
            </div>

            <div v-for="(doc, idx) in newDocuments" :key="'new-' + idx"
              class="d-flex align-items-center gap-2 px-3 py-2 mb-2 border rounded-3 bg-light" style="max-width:560px">
              <i class="bi bi-file-earmark-pdf-fill text-danger fs-4 flex-shrink-0"></i>
              <div class="flex-grow-1 text-truncate">
                <div class="small fw-semibold text-truncate">{{ doc.file.name }}</div>
                <small class="text-muted">{{ (doc.file.size / 1024).toFixed(0) }} KB</small>
              </div>
              <button type="button" class="btn btn-outline-danger btn-sm flex-shrink-0" title="Hapus"
                @click="removeNewDocument(idx)">
                <i class="bi bi-x-lg"></i>
              </button>
            </div>
  
            <button type="button" class="btn btn-sm btn-outline-secondary" @click="$refs.docInput.click()">
              <i class="bi bi-plus-lg"></i> Tambah Dokumen PDF
            </button>
            <input ref="docInput" type="file" accept=".pdf,application/pdf" multiple class="d-none"
              @change="addNewDocument" />
          </div>
        </div>
      </div>
  
      <!-- DETAIL ITEMS -->
      <div class="d-flex justify-content-between align-items-center mb-2">
        <p class="fw-semibold text-muted small text-uppercase mb-0">Detail Perangkat</p>
        <button type="button" class="btn btn-sm btn-outline-primary" @click="addDetailItem">
          + Add Detail
        </button>
      </div>
  
      <div v-for="(item, index) in detailItems" :key="index" class="border rounded p-3 mb-3">
        <!-- ITEM HEADER -->
        <div class="d-flex justify-content-between align-items-center mb-3">
          <p class="fw-semibold mb-0 small">Item #{{ index + 1 }}</p>
          <button v-if="detailItems.length > 1" type="button" class="btn btn-sm btn-outline-danger"
            @click="removeDetailItem(index)">
            Hapus Item
          </button>
        </div>
  
        <div class="row g-3">
          <div class="col-md-3">
            <label class="form-label fw-semibold">Jenis Perangkat <span class="text-danger">*</span></label>
            <Multiselect v-model="item.device_type_id" :options="getFilteredDeviceTypes()" valueProp="device_type_id"
              label="device_type_name" placeholder="Pilih Jenis Perangkat" :searchable="true" :can-clear="true"
              @change="(value) => onDeviceTypeChange(index, value)" />
          </div>
          <!-- <div class="col-md-3">
                              <label class="form-label fw-semibold">Tanggal Pembelian Item</label>
                              <input type="date" class="form-control" v-model="item.detail_tanggal_pembelian">
                            </div> -->
  
          <div class="col-md-3">
            <label class="form-label fw-semibold">Status</label>
            <select class="form-select" v-model="item.status">
              <option :value="1">Active</option>
              <option :value="0">Inactive</option>
              <option :value="2">Retired</option>
            </select>
          </div>
  
          <div class="col-md-3">
            <label class="form-label fw-semibold">Kondisi Barang</label>
            <select class="form-select" v-model="item.asset_condition">
              <option :value="null">-- Pilih Kondisi --</option>
              <option v-for="c in conditionList" :key="c.value" :value="c.value">{{ c.label }}</option>
            </select>
          </div>
  
          <!-- ASSET NUMBERS -->
          <div class="col-md-3">
            <label class="form-label fw-semibold">Nomor Aset <span class="text-danger">*</span></label>
            <div class="d-flex flex-wrap gap-2 align-items-center">
              <div v-for="(num, numIndex) in item.asset_numbers" :key="numIndex" class="input-group" style="width: auto">
                <input type="text" class="form-control" v-model="num.detail_asset_number"
                  :disabled="mode === 'edit' && !!num.infra_asset_number_id"
                  :class="{ 'bg-light': mode === 'edit' && !!num.infra_asset_number_id }">
                <button v-if="item.asset_numbers.length > 1 && !(mode === 'edit' && num.infra_asset_number_id)"
                  type="button" class="btn btn-danger" @click="removeAssetNumber(index, numIndex)">✕</button>
              </div>
              <button type="button" class="btn btn-success" @click="addAssetNumber(index)">
                +
              </button>
            </div>
          </div>
  
          <!-- SPECIFICATIONS (dynamic sesuai jenis perangkat, auto render) -->
          <div class="col-12">
            <hr class="mt-0 mb-2">
            <label class="form-label fw-semibold">Spesifikasi</label>
  
            <div v-if="!item.device_type_id" class="text-muted small">
              Pilih jenis perangkat dahulu untuk menampilkan field spesifikasi.
            </div>
            <div v-else-if="item.specifications.length === 0" class="text-muted small">
              Belum ada mapping spesifikasi untuk jenis perangkat ini.
            </div>
            <div v-else class="row g-3">
              <div v-for="spec in item.specifications" :key="spec.specification_id" class="col-md-3">
                <label class="form-label small">{{ spec.specification_name }}</label>
                <input type="text" class="form-control" v-model="spec.specification_value">
              </div>
            </div>
          </div>
  
          <!-- SUBSCRIPTION -->
          <div class="col-12">
            <hr class="mt-0 mb-1">
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" :id="`sub_${index}`" v-model="item.detail_subscription"
                :true-value="1" :false-value="0" />
              <label class="form-check-label fw-semibold" :for="`sub_${index}`">
                Perangkat ini memiliki subscription
              </label>
            </div>
          </div>
  
          <template v-if="item.detail_subscription">
            <div class="col-md-4">
              <label class="form-label fw-semibold">Start Date Subscription</label>
              <input type="date" class="form-control" v-model="item.detail_start_date_subscription">
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">End Date Subscription</label>
              <input type="date" class="form-control" v-model="item.detail_expired_date_subscription"
                :min="item.detail_start_date_subscription">
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">Nomor Kontrak</label>
              <input type="text" class="form-control" v-model="item.detail_subscription_contract_number">
            </div>
          </template>
        </div>
      </div>
  
      <!-- SUBMIT -->
      <div class="d-flex justify-content-end gap-2 mt-4">
        <button v-if="mode === 'add' || mode === 'edit'" class="btn btn-secondary" @click="goBack">
          Cancel
        </button>
        <button class="btn btn-primary" :disabled="isLoading" @click="saveData">
          <span v-if="isLoading" class="spinner-border spinner-border-sm me-1"></span>
          <i v-else class="bi bi-floppy"></i>
          {{ submitLabel }}
        </button>
      </div>
    </template>
  
  </div>
</template>

<script>
import InfrasFormViewJs from "./InfrasFormView";
export default InfrasFormViewJs;
</script>

<style scoped>
.uppercase-select :deep(.multiselect-search),
.uppercase-select :deep(.multiselect-single-label),
.uppercase-select :deep(.multiselect-option) {
  text-transform: uppercase;
}
</style>